import React, { createContext, useContext, useEffect, useRef, useState } from 'react';

interface FilterClickCheckState {
  tooltipsEnabled: boolean;
  setTooltipsEnabled: React.Dispatch<React.SetStateAction<boolean>>;
  registerRef: (ref: React.RefObject<HTMLDivElement>) => void;
  unregisterRef: (ref: React.RefObject<HTMLDivElement>) => void;
}

const FilterClickCheckContext = createContext<FilterClickCheckState>({
  tooltipsEnabled: true,
  setTooltipsEnabled: function (value: React.SetStateAction<boolean>): void {
    console.log('setTooltipsEnabled');
  },
  registerRef: function (ref: React.RefObject<HTMLDivElement>): void {
    console.log('registerRef');
  },
  unregisterRef: function (ref: React.RefObject<HTMLDivElement>): void {
    console.log('unregisterRef');
  },
});

type FilterClickCheckProviderType = {
  children: React.ReactNode;
};

const FilterClickCheckProvider: React.FC<FilterClickCheckProviderType> = ({ children }) => {
  const [tooltipsEnabled, setTooltipsEnabled] = useState<boolean>(true);
  const refs = useRef<React.RefObject<HTMLDivElement>[]>([]);

  const registerRef = (ref: React.RefObject<HTMLDivElement>) => {
    refs.current.push(ref);
  };

  const unregisterRef = (ref: React.RefObject<HTMLDivElement>) => {
    refs.current = refs.current.filter((r) => r !== ref);
  };

  useEffect(() => {
    const clickHandler = (event: MouseEvent) => {
      const isClickWithinDropdown = refs.current.some((e) => e?.current?.contains(event.target as Node) ?? false);

      setTooltipsEnabled(!isClickWithinDropdown);
    };

    document.addEventListener('click', clickHandler);

    return () => {
      document.removeEventListener('click', clickHandler);
    };
  }, []);

  return (
    <FilterClickCheckContext.Provider value={{ tooltipsEnabled, setTooltipsEnabled, registerRef, unregisterRef }}>
      {children}
    </FilterClickCheckContext.Provider>
  );
};

export const useFilterClickCheckContext = () => {
  const context = useContext(FilterClickCheckContext);
  if (!context) {
    throw new Error('useFilterClickCheckContext must be used within a FilterClickCheckProvider');
  }
  return context;
};

export default FilterClickCheckProvider;
